import { debounce } from '@nova/utils'

class NovaFiltersWrapper extends HTMLElement {
  constructor() {
    super()
    this.filterData = []
    this.debouncedOnSubmit = debounce(this.onSubmitHandler, 500)
  }

  connectedCallback() {
    this.$submitInputs = this.querySelectorAll('.js-filter-submit')
    this.$sortInput = this.querySelector('.js-sort-input')
    this.$mobileFiltersTrigger = this.querySelector(
      '.js-mobile-filters-trigger',
    )
    this.$mobileFiltersDrawer = this.querySelector('.js-mobile-filters')
    this.$closeButton = this.querySelector('.js-close')
    this.$filterCheckboxes = this.querySelectorAll('.js-filter-checkbox')
    this.$summaryFilterCountEl = document.querySelectorAll('.mobile-filters__content .js-filter-count')
    this.$totalFilterCountMarkers = document.querySelectorAll(
      '[data-total-filter-count]',
    )

    this.bindActiveFacetButtonEvents()
    window.addEventListener('popstate', this._onHistoryChange)
    document.body.addEventListener('click', this._closeDetails)

    for (const $element of this.$submitInputs) {
      $element.addEventListener('click', this.debouncedOnSubmit)
    }
    this.$sortInput?.addEventListener('sl-change', this.debouncedOnSubmit)
    this.$closeButton?.addEventListener('click', this._closeMobileFilters)

    for (const $checkbox of this.$filterCheckboxes) {
      $checkbox.addEventListener('sl-change', this._handleCheckboxChange)
    }

    this.$mobileFiltersTrigger?.addEventListener('click', () =>
      this.$mobileFiltersDrawer?.show(),
    )

    this.updateTotalFiltersCountFromStore = this.updateTotalFiltersCountFromStore.bind(this)

    this.$priceInputs = this.querySelector('.js-filter-price').querySelectorAll('sl-input')
    this.$priceInputs.forEach(elem => {
      elem.addEventListener('input', () => {
        let hasValue = false
        const $filterCount = elem.closest('.js-details-dropdown').querySelector('.js-filter-count')
        this.$priceInputs.forEach(childElem => {
          if(childElem.value.length) hasValue = true
        })
        if(hasValue) {
          $filterCount.dataset.filterCount = 1
        } else {
          $filterCount.dataset.filterCount = 0
        }
        this.updateTotalFiltersCount()
      })
    })
  }

  _handleCheckboxChange = (event) => {
    const isDesktop = event.target
      .closest('nova-filters-wrapper')
      .classList.contains('js-desktop-filters')

    const currentFilter = event.target
    this.updateSummaryFilterCount(currentFilter)

    const $wrapper = currentFilter.closest('.js-collection-filters')
    const $targetedFilterValue = currentFilter.value
    const $targetedFilterParamName = currentFilter.getAttribute('name')
    const $formItems = $wrapper.querySelectorAll(
      `sl-checkbox[name="${$targetedFilterParamName}"][value="${$targetedFilterValue}"]`,
    )
    for (const $formItem of $formItems) {
      if($formItem !== currentFilter) {
        if (currentFilter.checked) {
          $formItem.setAttribute('checked', true)
        } else {
          $formItem.removeAttribute('checked')
        }
      }
    }

    this.updateTotalFiltersCount()

    if (isDesktop) {
      this.debouncedOnSubmit(event)
    }
  }

  updateSummaryFilterCount(currentFilter) {
    if (currentFilter === 'Clear All') {
      const $filterCountElements = document.querySelectorAll(
        '[data-filter-count]',
      )
      for (const $filterCountElement of $filterCountElements) {
        $filterCountElement.dataset.filterCount = 0
        $filterCountElement.innerHTML = ''
      }
      return
    }

    const optionType = currentFilter.dataset.optionType
    const $filterCountElements = document.querySelectorAll(
      `[data-filter-count][data-filter-option='${optionType}'`,
    )
    const filterCountValue = Number.parseInt(
      $filterCountElements[0].dataset.filterCount,
    )
    let newCountValue

    if (currentFilter.checked) {
      newCountValue = filterCountValue + 1
    } else {
      newCountValue = filterCountValue - 1
    }

    for (const $element of $filterCountElements) {
      $element.dataset.filterCount = newCountValue
      $element.innerHTML = newCountValue > 0 ? ` (${newCountValue})` : ''
    }
  }

  updateTotalFiltersCount() {
    let filterCountSum = 0

    for (const $element of this.$summaryFilterCountEl) {
      filterCountSum += Number.parseInt($element.dataset.filterCount)
    }

    for (const $element of this.$totalFilterCountMarkers) {
      $element.innerHTML = filterCountSum > 0 ? ` (${filterCountSum})` : ''
    }
  }

  updateTotalFiltersCountFromStore(html) {
    const $activeFacetsElement = html.querySelector("[data-total-filter-count]")
    for (const $element of this.$totalFilterCountMarkers) {
      $element.innerHTML = $activeFacetsElement.innerHTML
    }
  }

  _closeMobileFilters = () => {
    this.$mobileFiltersDrawer?.hide()
  }

  _closeDetails(event) {
    const $detailsElements = this.querySelectorAll('.js-details-dropdown')
    for (const $element of $detailsElements) {
      if (!$element.contains(event.target)) {
        $element.open = false
      }
    }
  }

  onSubmitHandler = (event) => {
    event.preventDefault()
    const formData = new FormData(event.target.closest('form'))
    for (const [key, value] of formData) {
    }
    const searchParams = new URLSearchParams(formData).toString()
    this.renderPage(searchParams, event)
    this._closeMobileFilters()
  }

  clearFormValue(target) {
    const $targetedFilterValue =
      target.closest('.js-facet-remove').dataset.filterValue
    const $targetedFilterParamName =
      target.closest('.js-facet-remove').dataset.paramName

    if ($targetedFilterValue) {
      const $wrapper = target.closest('.js-collection-filters')
      if ($targetedFilterValue === 'Clear All') {
        const $formItems = $wrapper.querySelectorAll('sl-checkbox[checked]')
        for (const $formItem of $formItems) {
          $formItem.removeAttribute('checked')
        }
        $wrapper.querySelectorAll('sl-input').forEach(input => input.value = '')
        this.updateSummaryFilterCount('Clear All')
        this.updateTotalFiltersCount()
      } else {
        const $formItems = $wrapper.querySelectorAll(
          `sl-checkbox[name="${$targetedFilterParamName}"][value="${$targetedFilterValue}"]`,
        )
        for (const $formItem of $formItems) {
          $formItem.removeAttribute('checked')
        }
        this.updateSummaryFilterCount($formItems[0])
        this.updateTotalFiltersCount()
      }
    }

    this.$priceInputs.forEach(elem => elem.value = '')
  }

  _onActiveFilterClick = (event) => {
    event.preventDefault()
    this.toggleActiveFacets()
    this.clearFormValue(event.target)
    const formData = new FormData(
      event.target
        .closest('.collection-filters')
        .querySelector('.collection-filters__form'),
    )
    for (const [key, value] of formData) {
    }
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
  }

  _onHistoryChange = (event) => {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    const $removeFacets = document.querySelectorAll('.js-facet-remove')
    for (const $element of $removeFacets) {
      $element.classList.toggle('disabled', disable)
    }
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById('main-collection-product-grid')
      .querySelector('.js-product-grid')
      .classList.add('loading')

    const sections = this.getSections()
      .map((section) => `sections[]=${section.section}`)
      .join('&')

    const url = `${window.location.pathname}?${sections}&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.renderFilters(html, event)
        this.renderProductGrid(html)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderFilters(html, event)
    this.renderProductGrid(html)
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('main-collection-product-grid').innerHTML
    const productGrid = document.getElementById('main-collection-product-grid')

    productGrid.innerHTML = innerHTML

    const productCards = productGrid.querySelectorAll('nova-product-card')
    for (const productCard of productCards) {
      const swatchValuesTemplate = productGrid.querySelector(
        `#collection-grid__swatch-values-json-${productCard.id}`,
      )
      const sizeValuesTemplate = productGrid.querySelector(
        `#collection-grid__size-values-json-${productCard.id}`,
      )
      const variantsTemplate = productGrid.querySelector(
        `#collection-grid__variants-json-${productCard.id}`,
      )
      const swatchValues = swatchValuesTemplate
        ? JSON.parse(swatchValuesTemplate.content.textContent.trim())
        : []
      const sizeValues = sizeValuesTemplate
        ? JSON.parse(sizeValuesTemplate.content.textContent.trim())
        : []
      const variants = variantsTemplate
        ? JSON.parse(variantsTemplate.content.textContent.trim())
        : []
      productCard.swatches = swatchValues
      productCard.sizes = sizeValues
      productCard.variants = variants
    }
  }

  renderFilters(...args) {
    this.renderSingleFormFilters('#CollectionFiltersForm', ...args)
    this.renderSingleFormFilters('#CollectionFiltersFormMobile', ...args)
  }

  renderSingleFormFilters(form, html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const $facetDetailsElements = Array.from(
      parsedHTML.querySelectorAll(`${form} .js-filter`),
    )

    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest('.js-filter')?.dataset.index

    const $facetsToRender = $facetDetailsElements.filter(
      (element) => !matchesIndex(element),
    )

    for (const $element of $facetsToRender) {
      document.querySelector(
        `${form} .js-filter[data-index="${$element.dataset.index}"]`,
      ).innerHTML = element.innerHTML
    }

    this.renderActiveFacets(parsedHTML)
    this.updateTotalFiltersCountFromStore(parsedHTML)
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    for (const selector of activeFacetElementSelectors) {
      const $activeFacetsElement = html.querySelector(selector)
      if (!$activeFacetsElement) return
      document.querySelector(selector).innerHTML =
        $activeFacetsElement.innerHTML
    }

    this.bindActiveFacetButtonEvents()
    this.toggleActiveFacets(false)
  }

  bindActiveFacetButtonEvents() {
    const $removeFacets = document.querySelectorAll('.js-facet-remove')
    for (const $element of $removeFacets) {
      $element.addEventListener('click', this._onActiveFilterClick, {
        once: true,
      })
    }
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    )
  }

  getSections() {
    return [
      {
        id: 'main-collection-filters',
        section: document.getElementById('main-collection-filters').dataset.id,
      },
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset
          .id,
      },
    ]
  }
}

customElements.define('nova-filters-wrapper', NovaFiltersWrapper)
